__webpack_public_path__ = window.CNX.settings.url + '/assets/packaged/';
